/* eslint-disable react-refresh/only-export-components */
// File-level disable: we intentionally export ROLE_FULL_NAME alongside the
// component so consumers can render tooltip/aria text without re-deriving
// the map. Splitting into a separate constants module is pure overhead.
import type { FamRole } from "../lib/types";

interface RoleBadgeProps {
	role: FamRole;
}

// Short labels for the badge surface.
const LABEL: Record<FamRole, string> = {
	pm: "PM",
	rm: "RM",
	trader: "Trader",
	analyst: "Analyst",
	member: "Member",
};

// Full names for the hover tooltip + screen readers.
export const ROLE_FULL_NAME: Record<FamRole, string> = {
	pm: "Portfolio Manager",
	rm: "Risk Manager",
	trader: "Trader",
	analyst: "Analyst",
	member: "Member",
};

const COLOR: Record<FamRole, string> = {
	pm: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
	rm: "bg-sky-500/15 text-sky-300 border-sky-500/30",
	trader: "bg-amber-500/15 text-amber-300 border-amber-500/30",
	analyst: "bg-violet-500/15 text-violet-300 border-violet-500/30",
	member: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
};

export function RoleBadge({ role }: RoleBadgeProps) {
	return (
		<span
			className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${COLOR[role]}`}
			title={ROLE_FULL_NAME[role]}
			aria-label={ROLE_FULL_NAME[role]}
		>
			{LABEL[role]}
		</span>
	);
}
